import React, { useState, useEffect, FC } from "react";
import { submit_email, Email,decrypt_cookie } from "../api";
import styles from './ContactForm.module.css';
import { TextField } from '@fluentui/react';

interface FormData {
  first_name: string;
  last_name: string;
  job_title: string;
  company_name: string;
  sender_email: string;
  country: string;
  inquiry: string;
  chat_id: string | undefined;
}

interface SupportFormProps {
  onClose: () => void;
  chat_id: string | undefined;
}

const ContactForm: FC<SupportFormProps> = ({ onClose, chat_id }) => {
  const [cookie, setCookie] = useState<string | null>(null);

  const initialFormData: FormData = {
    first_name: "",
    last_name: "",
    job_title: "",
    company_name: "",
    sender_email: "",
    country: "",
    inquiry: "",
    chat_id: chat_id
  };

  const [formData, setFormData] = useState<FormData>(initialFormData);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleCancel = () => {
    setFormData(initialFormData);
    onClose();
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let email_sub: Email 
    email_sub = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        job_title: formData.job_title,
        company_name: formData.company_name,
        sender_email: formData.sender_email,
        country: formData.country,
        inquiry: formData.inquiry,
        chat_id: formData.chat_id,
    }
    submit_email(email_sub);
    onClose();
    console.log("sub")
    alert("Your inquiry has been submitted. A team member will respond soon!");
    // Perform form submission (e.g., send data to server)
  };

  return (
    // <div className="formContainer">
    <div className={styles.contactFormContainer}>
      <p className={styles.descContactForm}>Please fill out the following form and click Submit. A team member will respond to your inquiry within 48 hours. If this is time-sensitive, please contact your member engagement representative.</p>
      <h2 className={styles.titleContactForm}>Contact Form</h2>
      <form onSubmit={handleSubmit} className={styles.contactForm}>
        <label htmlFor="first_name">First Name</label >
        <input
          type="text"
          id="first_name"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          required
        />

      
        <label htmlFor="last_name">Last Name</label>
        <input
          type="text"
          id="last_name"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          required
        />

      
        <label htmlFor="job_title">Job Title</label>
        <input
          type="text"
          id="job_title"
          name="job_title"
          value={formData.job_title}
          onChange={handleChange}
          required
        />
        
      
        <label htmlFor="company_name">Company Name</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          value={formData.company_name}
          onChange={handleChange}
          required
        />
        
      
        <label htmlFor="sender_email">Company Email</label>
        <input
          id="sender_email"
          name="sender_email"
          value={formData.sender_email}
          onChange={handleChange}
          required
        />

        <label htmlFor="country">Country</label>
        <input
          id="country"
          name="country"
          value={formData.country}
          onChange={handleChange}
          required
        />
        
        <label htmlFor="inquiry">Inquiry</label>
        <textarea
          // type="text"
          id="inquiry"
          name="inquiry"
          className={styles.inquiry}
          value={formData.inquiry}
          onChange={handleChange}
          required
          rows={3}
        />
        <br/>

        <button type="submit" className={styles.btnContactForm}>Submit</button>
        <button type="button" className={styles.btnCancelContactForm} onClick={handleCancel}>
          Cancel
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
